export default __webpack_public_path__ + "static/media/Whatsapp.a6bd2eed.svg";